import styled from 'styled-components';
import { heading4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PrimaryContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
  @media screen and (max-width: ${pxToRem(893)}) {
    width: 100%;
  }
  @media screen and (min-width: ${pxToRem(894)}) {
    max-width: ${pxToRem(720)};
  }
`;

export const PrimaryContentTitle = styled.h2`
  ${heading4};
`;

export const PrimaryContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;
